






































































































































import Vue from "vue";
import {
  Container,
  RadioGroup,
  Radio,
  TextField,
  CalculatorTable,
  AssociationSelect,
} from "@/components";
import {
  CalculationFields,
  CalculationResponse,
  CalculationPayload,
  CalculatorViewData,
  EnrollmentCode,
  OrganizationMembership,
} from "@/types";
import apiClient from "@/services/api.client";
import { mapGetters } from "vuex";
import { getAllParentNhoNumbers } from "@/utils";
import { Federation } from "@/models/Federation";
import { Getters } from "@/store";
import LayoutDefault from "@/layouts/LayoutDefault.vue";

const initialFields = (): CalculationFields => ({
  salaryBase: 0,
  turnover: 0,
  otherFeeBase: 0,
  conflictFund: false,
  useCrmYearReport: false,
  nhoNumber: 0,
  calculationYear: new Date().getFullYear(),
  manualContingentRequest: "",
  useManualContingentRequest: false,
  membershipType: 0,
});

const membershipTypeItems = [
  {
    key: 0,
    display: "Ordinært",
  },
  {
    key: 1,
    display: "Fagmedlemskap",
  },
  {
    key: 2,
    display: "Ekstraordinært",
  },
];

const CONFLICTFUND_MO_NUMBER = 90000;

export default Vue.extend({
  name: "Calculator",
  components: {
    Container,
    RadioGroup,
    Radio,
    TextField,
    CalculatorTable,
    AssociationSelect,
    LayoutDefault,
  },
  data(): CalculatorViewData {
    return {
      fields: initialFields(),
      contingentThisYear: null,
      contingentOrdinaryYear: null,
      calculatingContingent: false,
      selectedAssociations: [],
      membershipType: 0,
    };
  },
  computed: {
    ...mapGetters([Getters.ASSOCIATIONS]),
  },
  mounted() {
    const { organizationNumber, year } = this.$route.query;
    if (organizationNumber && typeof organizationNumber === "string") {
      this.selectedAssociations = [parseInt(organizationNumber)];
    }
    if (year && typeof year === "string") {
      this.fields.calculationYear = parseInt(year);
    }
  },
  methods: {
    getAllParentNhoNumbers: getAllParentNhoNumbers,
    getMembershipTypes(): Array<{ key: number; display: string }> {
      return membershipTypeItems;
    },
    isUsingCrmYearReport() {
      return this.fields.useCrmYearReport;
    },
    resetData() {
      Object.assign(this.fields, initialFields());
    },
    getIdFromNhoNumber(nhoNumber: number): number {
      return (
        this.associations.find(
          (org: Federation) => org.nhoNumber === nhoNumber
        )?.id ?? ""
      );
    },
    calculateContingent() {
      let memberships: number[] = [];

      this.selectedAssociations.forEach((associationNumber) => {
        {
          memberships = memberships.concat(
            getAllParentNhoNumbers(associationNumber, this.associations)
          );
        }
      });

      if (this.fields.conflictFund) memberships.push(CONFLICTFUND_MO_NUMBER);

      const organizationMemberships: Array<OrganizationMembership> =
        memberships.map((m) => {
          return {
            startDate: new Date(),
            endDate: null,
            moNumber: m,
            enrollmentCode: EnrollmentCode.Nyinnmelding,
            membershipType: this.membershipType,
          };
        });

      let payload: CalculationPayload = {
        ...this.fields,
        organizationMemberships,
      };

      if (this.fields.useManualContingentRequest) {
        try {
          payload = JSON.parse(this.fields.manualContingentRequest);
        } catch (error: any) {
          this.$toast.error("Ugyldig rådata | " + error.toString());
          return;
        }
      }

      this.calculatingContingent = true;

      apiClient
        .calculateContingent(payload)
        .then((data: CalculationResponse) => {
          this.calculatingContingent = false;

          this.contingentThisYear = data.kontingentIAr
            ? data.kontingentIAr
            : null;
          this.contingentOrdinaryYear = data.kontingentOrdinartAr
            ? data.kontingentOrdinartAr
            : null;

          this.$toast.success("Kontingent beregnet. Se tabell.");
        })
        .catch((error: any) => {
          this.calculatingContingent = false;
          const message =
            error.response.status == 400 &&
            typeof error.response.data == "string"
              ? error.response.data
              : "Kunne ikke beregne kontingent.";
          this.$toast.error(message);
        });
    },
  },
});
